import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ContextService } from './context.service';
import { Octopus, CustomizationString } from '@maximizer/core/shared/domain';

@Injectable()
export class CustomizationStringService {
  constructor(
    private readonly http: HttpClient,
    private readonly context: ContextService,
  ) {}

  getCustomizationStrings(): Observable<CustomizationString[]> {
    const request: Octopus.CustomizationStringReadRequest = {
      CustomLabel: {
        Criteria: {
          SearchQuery: {
            Type: {
              $IN: [
                Octopus.EntityType.AbEntry,
                Octopus.EntityType.Opportunity,
                Octopus.EntityType.Case,
              ],
            },
          },
        },
        Scope: {
          Fields: {
            ResourceID: 1,
            Labels: 1,
          },
        },
      },
    };

    return this.http
      .post<Octopus.CustomizationStringResponse>(
        `${this.context.api}${Octopus.Action.READ}`,
        request,
      )
      .pipe(
        map((result) => {
          if (result.Code === Octopus.ResponseStatusCode.Successful) {
            const mapper = new Octopus.CustomizationStringMapper();
            return result.CustomLabel.Data.map((items) => mapper.from(items));
          }
          return [];
        }),
      );
  }
}
